import { useState } from "react";
import { games } from "@/mocks/games";

export default function GamesSection() {
  const [activeGame, setActiveGame] = useState<number | null>(null);
  return (
    <section className="py-20 max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="mb-14">
        <div className="text-[#00ff88] text-xs tracking-[0.3em] uppercase font-semibold mb-4 font-inter">Our Games</div>
        <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tight font-syne">The AWWAL Game Universe</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {games.map((g) => (
          <div
            key={g.id}
            className="group relative rounded-sm overflow-hidden cursor-pointer border border-white/5 hover:border-[#00ff88]/30 transition-all"
            onClick={() => setActiveGame(activeGame === g.id ? null : g.id)}
          >
            <div className="w-full h-56 overflow-hidden">
              <img src={g.image} alt={g.title} title={g.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#080808] via-[#080808]/40 to-transparent" />
            </div>
            <div className="absolute top-3 right-3">
              <span className={`px-2.5 py-1 text-[10px] font-bold tracking-widest uppercase rounded-sm font-inter ${g.status === "Live" ? "bg-[#00ff88]/20 text-[#00ff88] border border-[#00ff88]/30" : "bg-[#f59e0b]/20 text-[#f59e0b] border border-[#f59e0b]/30"}`}>{g.status}</span>
            </div>
            <div className="p-5">
              <div className="text-white/35 text-[10px] tracking-widest uppercase mb-1.5 font-inter">{g.genre} · {g.platform}</div>
              <h3 className="text-white font-bold text-base mb-2 font-syne">{g.title}</h3>
              {activeGame === g.id && <p className="text-white/45 text-sm leading-relaxed mb-3 font-inter">{g.desc}</p>}
              <div className="flex flex-wrap gap-1.5 mb-3">
                {g.tags.map((tag) => (
                  <span key={tag} className="px-2 py-0.5 text-[10px] font-semibold tracking-wide text-white/40 border border-white/10 rounded-sm font-inter">{tag}</span>
                ))}
              </div>
              <div className="flex items-center gap-1.5 text-[#00ff88] text-xs font-semibold font-inter">
                <div className="w-4 h-4 flex items-center justify-center"><i className="ri-user-line text-xs leading-none" /></div>
                <span>{g.players} Players</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
